<template>
	<div class="cui-login-wrapper">

		<header class="h-font">
			<img class="h-img--f" src="@/assets/img/login/left-top-font.png" alt="">
			<img class="h-img--l" src="@/assets/img/login/left-font.png" alt="">
			<span class="h-span"><a href="http://www.ciicpt.com.cn/">{{$t("logon.about"/**关于我们*/)}}</a></span>
		</header>

		<section class="s-content">
			<div v-if="loginMethod =='pwd'" class="animated fadeIn" key="box1">
				<code-login :loginMethod.sync="loginMethod"></code-login>
			</div>
			<div v-else key="box2" class="animated fadeIn">
				<pwd-login :loginMethod.sync="loginMethod"></pwd-login>
			</div>
		</section>

	  	<footer class="f-copyright">
        {{$t("logon.copyRight"/**版权所有*/)}}
	  	</footer>
  	</div>
</template>

<script>
import { setRem } from '@/util/commen.js'
import codeLogin from './codelogin'
import pwdLogin from './pwdlogin'
import { mapGetters } from 'vuex'

export default {
	name: 'codelogin',

	components: { codeLogin, pwdLogin },

	data() {
		return {
			loginMethod: 'code'
		}
	},

	computed: {
      ...mapGetters([ 'lang' ]),
    },

	created() {
		setRem()
		localStorage.setItem('version', this.$route.meta.version)
	},
}
</script>

<style lang="scss" scoped>
.cui-login-wrapper {
	position: relative;
	width: 100%;
	height: 100%;
	background: url(../../assets/img/loginbg3.png) 0 0 no-repeat;
	background-size: cover;
	overflow: auto;

	.h-font {
		margin-left: 1.20rem;
		img,span { display: block; }
		.h-img--f {
			width: 2.50rem;
			padding-top: 0.54rem;
		}
		.h-img--l {
			margin-top: 1.76rem;
			width: 8.10rem;
		}
		.h-span {
			width: 1.52rem;
			height: 0.54rem;
			border-radius: 6px;
			border: 1px solid #014897;
			margin-top: 0.40rem;
			margin-left: 0.1rem;
			font-size: 0.22rem;
			line-height: 0.54rem;
			font-weight: bold;
			color: #014897;
			text-align: center;
		}
		a:hover {
			text-decoration: none;
		}
	}

	.f-copyright {
		position: absolute;
		bottom: 0.15rem;
		width: 100%;
		text-align: center;
		font-size: 0.20rem;
		color: #fff;
	}

	.s-content {
		position: absolute;
		top: 2.16rem;
		left: 12.19rem;
		width: 5.10rem;
		min-height: 5.81rem;
		background: #FFFFFF;
		border-radius: 0.10rem;
	}
}
</style>

